import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  Container,
  Avatar,
  IconButton,
} from "@mui/material";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import PersonIcon from "@mui/icons-material/Person";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import GetAppIcon from "@mui/icons-material/GetApp";
import SendIcon from "@mui/icons-material/Send";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Link } from "react-router-dom";
import "./ActivityLog.css";

function ActivityLog() {
  const [open, setOpen] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [jsonData, setJsonData] = useState(null);
  const [dateColors, setDateColors] = useState({});
  const [filter, setFilter] = useState("All");
  const [selectedDate, setSelectedDate] = useState(null);
  const iconButtonRef = useRef(null);

  const handleCalendarOpen = () => setOpen(true);
  const handleCalendarClose = () => setOpen(false);
console.log("jero")
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`/api/enquiry-logs/`);
        const data = await response.json();
        setJsonData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!jsonData) return;

    const colorPalette = ["#fb7102"];
    const colors = {};
    jsonData.forEach((log) => {
      const date = new Date(log.timestamp).toLocaleDateString();
      if (!colors[date]) {
        colors[date] =
          colorPalette[Object.keys(colors).length % colorPalette.length];
      }
    });
    setDateColors(colors);
  }, [jsonData]);

  const handleListItemClick = (activity) => {
    setSelectedActivity(activity);
    setOpen(true);
  };

  const closeDrawer = () => {
    setSelectedActivity(null);
    setOpen(false);
  };

  if (!jsonData) {
    return null;
  }

  const formatDateAndTime = (timestamp) => {
    const date = new Date(timestamp);
    return {
      formattedDate: date.toLocaleDateString(),
      formattedTime: date.toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit",
      }),
    };
  };

  const formatUpdateTime = (updateTime) => {
    if (!updateTime) return "Unknown";

    const [hours, minutes, seconds] = updateTime.split(":").map(parseFloat);
    const days = Math.floor(hours / 24);
    const remainingHours = Math.floor(hours % 24);
    const formattedMinutes = Math.floor(minutes);
    const formattedSeconds = Math.floor(seconds);

    let formattedTime = "";
    if (days > 0) formattedTime += `${days} days `;
    if (remainingHours > 0) formattedTime += `${remainingHours} hours `;
    if (formattedMinutes > 0) formattedTime += `${formattedMinutes} minutes `;
    if (formattedSeconds > 0) formattedTime += `${formattedSeconds} seconds `;

    return formattedTime.trim();
  };

  function getTimeSince(dateString) {
    const now = new Date();
    const past = new Date(dateString);
    const seconds = Math.floor((now - past) / 1000);

    if (seconds < 60) return "just now";
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days} day${days > 1 ? "s" : ""} ago`;
    const weeks = Math.floor(days / 7);
    if (weeks < 4) return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;
    const years = Math.floor(days / 365);
    return `${years} year${years > 1 ? "s" : ""} ago`;
  }

  const iconMapping = {
    PlayArrowIcon: <PlayArrowIcon className="activity-icon play-icon" />,
    PauseIcon: <PauseIcon className="activity-icon pause-icon" />,
    EditIcon: <EditIcon className="activity-icon edit-icon" />,
    AddIcon: <AddIcon className="activity-icon add-icon" />,
    GetAppIcon: <GetAppIcon className="activity-icon get-app-icon" />,
    SendIcon: <SendIcon className="activity-icon send-icon" />,
    CloudUploadIcon: <CloudUploadIcon className="activity-icon cloud-upload-icon" />,
  };

  const filteredActivities = filter === "Today"
    ? jsonData.filter(
        (activity) =>
          new Date(activity.timestamp).toLocaleDateString() ===
          new Date().toLocaleDateString()
      )
    : filter === "Date" && selectedDate
      ? jsonData.filter(
          (activity) =>
            new Date(activity.timestamp).toLocaleDateString() ===
            selectedDate.toLocaleDateString()
        )
      : jsonData;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} >
      <Container className="activity-log-container">
        <Box className="header-section">
          <Typography className="header-title">
            <img
              src="./Activelog.jpeg"
              alt="Activity Log"
              className="header-icon"
            />
            Activity Log
          </Typography>
          <Typography className="header-date">
            {new Date().toLocaleString("en-US", {
              weekday: "short",
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })}
          </Typography>
        </Box>

        <Box className="filter-tabs">
          <Typography
            className={`filter-tab ${filter === "All" || filter === "Date" ? "active" : ""}`}
            onClick={() => {
              setFilter("All");
              setSelectedDate(null);
            }}
          >
            All
          </Typography>
          <Typography
            className={`filter-tab ${filter === "Today" ? "active" : ""}`}
            onClick={() => {
              setFilter("Today");
              setSelectedDate(null);
            }}
          >
            Today
          </Typography>
          {(filter === "All" || filter === "Date") && (
            <>
              <IconButton onClick={handleCalendarOpen} className="calendar-icon">
                <CalendarTodayIcon />
              </IconButton>
              <DatePicker
                open={open}
                onClose={handleCalendarClose}
                value={selectedDate}
                onChange={(newValue) => {
                  setSelectedDate(newValue);
                  setFilter("Date");
                  setOpen(false);
                }}
                slotProps={{
                  textField: { style: { display: "none" } },
                  popper: {
                    className: "custom-datepicker-popper",
                  },
                }}
              />
            </>
          )}
        </Box>

        <Box className="timeline-container">
          {Object.entries(
            filteredActivities.reduce((acc, activity) => {
              const date = new Date(activity.timestamp).toLocaleDateString();
              if (!acc[date]) acc[date] = [];
              acc[date].push(activity);
              return acc;
            }, {})
          )
            .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA))
            .map(([date, activities]) => (
              <Box key={date} className="timeline-date-section">
                <Typography className="timeline-date">
                  {date === new Date().toLocaleDateString() ? "" : date}
                </Typography>

                <Box className="timeline-wrapper">
                  <Box className="timeline-line" />

                  {activities.map((activity, idx) => (
                    <Box
                      key={activity.id}
                      className="activity-log-timeline-item"
                      onClick={() => handleListItemClick(activity)}
                    >
                      <Box className="timeline-time">
                        <Typography className="time-text">
                          {formatDateAndTime(activity.timestamp).formattedTime}
                        </Typography>
                      </Box>
                      <Box className="timeline-dot-container">
                        <Box
                          className={`timeline-dot ${
                            idx % 2 === 0 ? "dot-orange" : "dot-green"
                          }`}
                        />
                      </Box>
                      <Box className="timeline-content">
                        <Box className="content-top">
                          {iconMapping[activity.icon] || (
                            <PersonIcon className="default-icon" />
                          )}
                          <Typography className="action-text">
                            {activity.action}
                          </Typography>
                        </Box>

                        <Box className="content-bottom">
                          <Avatar
                            src="https://e7.pngegg.com/pngimages/114/356/png-clipart-time-student-recruitment-learning-professional-others-service-vector-icons-thumbnail.png"
                            className="content-avatar"
                          />
                          <Typography className="name-text">
                            {activity.name}
                          </Typography>
                          <Typography className="time-since-text">
                            {getTimeSince(activity.timestamp)}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}
        </Box>
      </Container>
    </LocalizationProvider>
  );
}

export default ActivityLog;